import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const LinedThumbsUp: FunctionalComponent<IIconProps> = ({
  width = '16',
  height = '16',
  fill = '#666',
  selected = false,
  disabled = false,
}) => {
  return selected ? (
    /*@ts-ignore*/
    <svg viewBox="0 0 24 24" width={width} height={height} fill="none">
      <path
        fill={disabled ? '#ccc' : selected ? '#458500' : fill}
        fill-rule="evenodd"
        d="M12.518 2.412c.541-.548 1.419-.548 1.97-.01.335.335.475.809.382 1.273l-.887 4.513h4.541c.471 0 .937.092 1.37.272 1.763.735 2.58 2.719 1.824 4.432l-2.534 5.744c-.365.828-1.203 1.364-2.13 1.364H9.317C8.037 20 7 18.993 7 17.75V9.07c0-.567.22-1.114.619-1.53l4.9-5.128zM3.5 20c-.825 0-1.5-.75-1.5-1.667V9.667C2 8.75 2.675 8 3.5 8S5 8.75 5 9.667v8.666C5 19.25 4.325 20 3.5 20z"
        clip-rule="evenodd"
      />
    </svg>
  ) : (
    /*@ts-ignore*/
    <svg viewBox="0 0 16 16" width={width} height={height} fill="none">
      <path
        fill={disabled ? '#ccc' : fill}
        fill-rule="evenodd"
        d="M11.12 13H3.334c-1.104 0-2-.896-2-2V7c0-1.105.896-2 2-2H4.86c.087-.183.202-.353.342-.504l2.82-3.04.008-.007c.57-.595 1.507-.599 2.091-.01.347.356.493.858.398 1.345l-.36 1.882h1.809c.361 0 .718.074 1.05.216 1.354.58 1.981 2.148 1.401 3.501l-1.459 3.404c-.315.736-1.038 1.212-1.838 1.212zm-6.453-2V6.332H3.333c-.368 0-.666.298-.666.666v4c0 .369.298.667.666.667H4.78c-.073-.208-.113-.433-.113-.667zm1.511-5.597c-.114.123-.178.285-.178.453V11c0 .369.298.667.667.667h4.454c.266 0 .508-.159.613-.404l1.459-3.404c.29-.677-.024-1.46-.7-1.75-.167-.072-.345-.109-.526-.109h-3.42l.151-.791.51-2.677c.013-.063-.004-.121-.038-.157-.054-.054-.127-.055-.177-.005L6.178 5.403z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export default LinedThumbsUp;
